"use strict";
angular.module("weiboSecondChannelHotSpotsModule", []).
controller("weiboSecondChannelHotSpotsCtrl", ["$scope", "$state", "trsHttpService", "$stateParams", function($scope, $state, trsHttpService, $stateParams) {
    initStatus();
    initData();
    /** [initStatsus description] 初始化状态 */
    function initStatus() {
        $scope.data = {
            weiboSecondList: [],
        }
    }
    /** [initData description] 初始化数据 */
    function initData() {
        requestData();
    }
    /** [requestData description]获取数据 */
    function requestData() {
        var params = {
            modelid: 'getWeibohotmessagebyevent',
            serviceid: 'weibohotpointmgr',
            batch: $stateParams.batchid,
            id: $stateParams.eventid,
            typeid: "widget"
        }
        trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'get').then(function(data) {
            $scope.data.weiboSecondList = data.PAGEITEMS;
        });
    }
    /** [viewOriginal description] 打开原微博查看详情 */
    $scope.viewOriginal = function(item) {
        var url = item.URLNAME;
        window.open(url);
    }
}]);